import { get } from "@insite/client-framework/Services/ApiService";
import {
    GetCompatibleVehiclesApiParameter,
    GetCompatibleVehiclesResultModel,
} from "@store/Store/Pages/ProductDetails/Handlers/GetCompatibleVehiclesList";

const compatibleVehiclesUrl = "api/v1/rssw/compatiblevehicles";

export async function getCompatibleVehicles(
    parameter: GetCompatibleVehiclesApiParameter,
): Promise<GetCompatibleVehiclesResultModel> {
    const { productId } = { ...parameter };
    try {
        const compatibleVehicles = await get<any>(`${compatibleVehiclesUrl}/${productId}`);
        return {
            result: compatibleVehicles,
        };
    } catch (error) {
        return {
            result: "",
        };
    }
}
